export const selectedIdsHashSelector = (state: RootState) => state.common.idsSelectors.selectedIds;
export const excludedIdsHashSelector = (state: RootState) => state.common.idsSelectors.excludedIds;
export const isIdsSelectingHashSelector = (state: RootState) =>
  state.common.idsSelectors.isSelecting;
export const isNeedToSelectAllHashSelector = (state: RootState) =>
  state.common.idsSelectors.isNeedToSelectAll;
